// extracted by mini-css-extract-plugin
export default {"notificationsButtonWrapper":"tfWk3PnDDVO9dhY951lV","notificationsButton":"s3v6fLBzjDBQPNwJCkLf","unreadBadge":"HgP1bEIzLuBAt0XBbAHZ"};